import { render } from "./ActiveConfirmModal.vue?vue&type=template&id=3848972a"
import script from "./ActiveConfirmModal.vue?vue&type=script&lang=js"
export * from "./ActiveConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__